



































import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import SelectOption from "@/common/ui/presenters/select-option";
import { ProjectStatusTypes } from "@/models/project-status";
import { SearchProjectCalendarQuery } from "@/api/project/project-calendar-api";

@Component({})
export default class ProjectCalendarSearchBar extends Vue {
  @Prop({ default: () => {} }) defaultQuery!: SearchProjectCalendarQuery;
  @Prop({ default: () => [] }) staffOptions!: SelectOption[];
  @Prop({ default: () => [] }) companyOptions!: SelectOption[];
  @Prop({ default: () => [] }) roleOptions!: SelectOption[];

  query: SearchProjectCalendarQuery = {
    status: "",
    staff: "",
    company: "",
    role: ""
  };

  get statusOptions(): SelectOption[] {
    return [
      {
        text: "全ての現場",
        value: ""
      }
    ].concat(
      ProjectStatusTypes.map(t => ({
        text: t,
        value: t
      }))
    );
  }

  @Watch("defaultQuery", { immediate: true })
  onDefaultQueryChanged() {
    this.query = { ...this.query, ...this.defaultQuery };
  }

  submit() {
    this.$emit("submit", this.query);
  }
}
